export default __webpack_public_path__ + "64a9dc5d82cc1a0ba0756380afed2460.svg";